import { useState } from 'react';
import { TopToolbar, usePermissions, useTranslate } from 'react-admin';
import { Button as MaterialButton } from '@mui/material';
import ExportResource from '@/components/global/buttons/ExportResource.jsx';
import ImportIcon from '@/assets/icons/import-icon.svg?react';
import CustomToolbarActionsPopover from '@/components/global/buttons/CustomToolbarActionsPopover';
import { CustomSelectColumnsButton } from '@/components/global/buttons/CustomSelectColumnsButton.jsx';
import ColumnsIcon from '@/assets/icons/columns-icon.svg?react';
import { SearchFilterInput } from '@/components/global/filters/SearchFilterInput';
import ImportDrawer from '@/components/global/import/ImportDrawer.jsx';
import CustomFilterButton from '@/components/global/filters/CustomFilterButton';
import CachedDataActionButton from '@/components/global/buttons/CachedDataActionButton.jsx';

export const NewDeviceListActions = () => {
    const translate = useTranslate();
    const [importDrawerOpen, setImportDrawerOpen] = useState(false);
    const { isLoading, permissions } = usePermissions();
    if (isLoading) return null;

    const openImport = () => {
        setImportDrawerOpen(true);
    };

    return (
        <>
            <ImportDrawer
                open={importDrawerOpen}
                onClose={() => setImportDrawerOpen(false)}
                title={translate('common.importSection.title')}
                resource='device'
                dataTransformer='csv-device'
                placeholderText={translate('common.importSection.placeholder')}
                showVerifyOnly={true}
                showValidationDetails={true}
            />
            <TopToolbar>
                <SearchFilterInput />
                <CustomFilterButton />
                <CustomSelectColumnsButton startIcon={<ColumnsIcon />} style={{ margin: '0px -4px' }} />
                <CustomToolbarActionsPopover>
                    <ExportResource resource='device' format='csv' dataTransformer='devices-to-csv-data' />
                    {permissions.isAdmin && (
                        <MaterialButton color='primary' size='small' startIcon={<ImportIcon />} onClick={openImport}>
                            {translate('common.importSection.importFromCsv')}
                        </MaterialButton>
                    )}
                    {permissions.isAdmin && <CachedDataActionButton resource='device' type={null} />}
                </CustomToolbarActionsPopover>
            </TopToolbar>
        </>
    );
};
